
export default {
  toggleVisibilityShortcutAlert ({ commit }) {
    commit('TOGGLE_VISIBILITY_SHORTCUT_ALERT');
  },
};
